import { ReactElement } from 'react';

import { useTheme } from '../../../../theme/useTheme';

export const ScreenShareIcon = ({ className }: { className: string }): ReactElement => {
	const theme = useTheme();
	const { fill, width, height } = theme.chat.header.select.screenShareIcon;
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 3H3.00001C1.89545 3 1 3.89545 1 5.00001V17C1 18.1046 1.89545 19 3.00001 19V17V5.00001H21V17V19C22.1045 19 23 18.1046 23 17V5.00001C23 3.89545 22.1045 3 21 3Z"
				fill={fill}
			/>
			<path
				d="M17.4427 18.713L12.982 13.4797C12.4435 12.848 11.5736 12.8495 11.0364 13.4797L6.57565 18.713C5.49482 19.9809 5.97202 21 7.6321 21H16.3863C18.0492 21 18.5194 19.9761 17.4427 18.713ZM8.96117 18.999L12.0092 15.4231L15.0572 18.999H8.96117Z"
				fill={fill}
			/>
		</svg>
	);
};
